<div class="app-shell">
	<app-nav-modules />

	<main class="app-content" id="app-content" tabindex="-1">
		<router-outlet />
	</main>
</div>
